/// <amd-module name="Tfs/Frame/Components/SuiteLogo/SuiteLogo" />
import * as React from "react";
import * as Resources from "Tfs/Frame/Resources";

import { IReadonlyObservableValue } from "VSS/Core/Observable";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { routeUrl } from "VSS/Platform/Location";
import { IVssPageService } from "VSS/Platform/Page";
import { UserClaims, userHasClaim } from "VSS/Platform/UserClaims";

import { Icon } from "VSSUI/Icon";
import { Observer } from "VSSUI/Observer";

import { FPSLink } from "VSS/Features/PlatformUI/FPSLink";

import { ITfsNavigationService, NavigationDisplayMode } from "Tfs/Platform/Navigation";

import { ISuiteLogoProps } from "./SuiteLogo.Props";

import { ScreenContext, ScreenSize } from "VSS/Core/Util/Screen";

export class SuiteLogo extends VssComponent<ISuiteLogoProps> {
    private expanded: IReadonlyObservableValue<NavigationDisplayMode> | NavigationDisplayMode;
    private isHosted: boolean;
    private href: string | undefined;

    public constructor(props: ISuiteLogoProps, context: IVssComponentContext) {
        super(props, context);

        if (props.routeId && userHasClaim(this.context.pageContext, UserClaims.Member)) {
            this.href = routeUrl(this.context.pageContext, props.routeId);
        }

        // Determine whether or not this is a Hosted or OnPrem deployment.
        const vssPageService = context.pageContext.getService<IVssPageService>("IVssPageService");
        const pageData = vssPageService.getData()!;
        this.isHosted = pageData.isHosted;

        if (!this.props.alwaysExpanded) {
            // Save the observable expanded nature of the logo in our component state.
            const navService = context.pageContext.getService<ITfsNavigationService>("ITfsNavigationService");
            this.expanded = navService.getNavigationDisplayMode();
        } else {
            this.expanded = NavigationDisplayMode.Expanded;
        }
    }

    public render(): JSX.Element {
        return (
            <ScreenContext.Consumer>
                {screen => (
                    <Observer key="suite-logo" expanded={this.expanded} size={screen.size}>
                        {(props: { expanded: NavigationDisplayMode; size: ScreenSize }) => (
                            <>
                                <a href="#skip-to-main-content" className="skip-to-main-content bolt-button enabled bolt-focus-treatment">{Resources.SkipToMainContent}</a>
                                <FPSLink
                                    ariaLabel={this.isHosted ? Resources.SuiteLogoLabel : Resources.SuiteLogoLabelOnPrem}
                                    className="commandbar-item suite-logo flex-row flex-noshrink flex-center"
                                    href={this.href}
                                    id="suite-logo"
                                    telemetrySource="applicationLink"
                                    removeUnderline={true}
                                >
                                    <Icon className="suite-image commandbar-icon justify-center" iconName="VSTSLogo" />
                                    {(props.expanded === NavigationDisplayMode.Expanded ||
                                        this.props.alwaysExpanded ||
                                        props.size <= ScreenSize.xsmall) && (
                                        <span className="brand body-m font-weight-heavy">
                                            {Resources.BrandName} {Resources.ProductName}
                                        </span>
                                    )}
                                </FPSLink>
                            </>
                        )}
                    </Observer>
                )}
            </ScreenContext.Consumer>
        );
    }
}

VssComponent.register("ms.vss-tfs-web.suite-logo", SuiteLogo);
